export function convertToHttpHost(value: string): string {
  return /https?/.test(value) ? value : `http://${value}`;
}
